import { useQuery } from "@tanstack/react-query";
import React from "react";
import "react-quill/dist/quill.snow.css";
import {  useParams } from "react-router-dom";
import { getPostComments } from "../../service/api";
import Comment from "./components/Comment";

export default function Comments() {
  const { id } = useParams();
  const commetnsQuery = useQuery(['comments'], () => getPostComments(id))


  return (
    <div className="flex flex-col-reverse font-body justify-end gap-3 p-4 h-[88vh]">
      {commetnsQuery?.data?.map(comment => <Comment comment={comment} comments={commetnsQuery?.data}/>)}
    </div>
  );
}
